import type { SiteConfig, SiteMode } from '~/constants/siteConfig'

/**
 * Visitor light/dark mode for tenant public sites. The platform-wide color
 * mode (Nuxt UI) is the source of truth — site-themes.css maps the global
 * `.dark` class onto the site tokens when the scope is in 'auto' mode — but
 * the tenant's configured default_mode seeds first-time visitors who have
 * no stored preference yet.
 */
export function useSiteMode(site: MaybeRefOrGetter<SiteConfig | null | undefined>) {
  const colorMode = useColorMode()

  onMounted(() => {
    const cfg = toValue(site)
    if (cfg && colorMode.preference === 'system') {
      colorMode.preference = cfg.default_mode
    }
  })

  const mode = computed<SiteMode>(() => (colorMode.value === 'dark' ? 'dark' : 'light'))
  const toggle = () => {
    colorMode.preference = mode.value === 'dark' ? 'light' : 'dark'
  }

  return { mode, toggle }
}
